import { createTheme } from "@mui/material/styles";

// import colors from "./base/color";


// export default createTheme({
//   palette: {...colors}
// });

import { grey, blue, common } from '@mui/material/colors';

const palette = {
  light: {
    primary: {
      main: '#009EF7',
      light: '#009EF7',
      // dark: '#00765A',
    },
    success: {
      main: '#50CD89',
      light: '#50CD89',
    },
    error: {
      main: '#F1416C',
      light: '#F1416C',
    }
  },
};

const theme = createTheme({});

export const getDesignTokens = (mode) => ({
  palette: {
    mode,
    ...(mode === 'light'
      ? {
        primary: {
          main: palette.light.primary.main,
          light: palette.light.primary.light,
          dark: palette.light.primary.dark,
        },

        success: {
          main: palette.light.success.main,
        },

        error: {
          main: palette.light.error.main,
        },

        divider: grey[300],
        text: {
          primary: grey[500],
          secondary: grey[800],
        },
      }
      : {
        primary: {
          main: palette.light.primary.main,
          default: '#19191e'
        },
        success: {
          main: palette.light.success.main,
        },
        error: {
          main: palette.light.error.main,
        },
        background: {
          default: '#19191e',
          paper: '#19191e',
        },
        text: {
          default: '#fff',
          paper: '#fff'
        },
        // divider: deepOrange[700],
        // background: {
        //   default: deepOrange[900],
        //   paper: deepOrange[900],
        // },
        // text: {
        //   primary: '#fff',
        //   // secondary: grey[500],
        // },
      }),
  },
  typography: {
    fontFamily: [
      'Poppins',
      'Helvetica',
      // 'Oswald',
      // 'Roboto',
      // '"Helvetica Neue"',
      // 'Arial',
      'sans-serif',
    ].join(','),
    body: {
      fontFamily: 'Poppins, Helvetica, sans-serif',
    },
  },
});

export const getThemedComponents = (mode) => ({
  components: {
    ...(mode === 'light'
      ? {
        MuiAppBar: {
          styleOverrides: {
            colorPrimary: {
              backgroundColor: grey[800],
            },
          },
        },
        MuiContainer: {
          styleOverrides: {
            maxWidthLg: {
              [theme.breakpoints.up('lg')]: {
                  maxWidth: '1320px',
              },
            },
          },
        },
        MuiLink: {
          defaultProps: {
            underline: 'none',
          },
          styleOverrides: {
            root: {
              color: '#5e6278',
              fontSize: '13px',
              fontWeight: 500,
            }
          }
        },
        MuiFormHelperText: {
          styleOverrides: {
            root: {
              color: 'red'
            }
          }
        },
        MuiTableRow: {
          styleOverrides: {
            root: {
              "&:hover": {
                backgroundColor: "transparent !important"
              }
            }
          }
        },
		    MuiTableCell: {
          styleOverrides: {
            root: {
              color: '#181c32',
              borderBottom: '1px dashed #ddd',
            },
          }
        },
        MuiInput: {
          defaultProps: {
            disableUnderline: true,
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              color: '#5e6278',
              background: '#f5f8fa',
              borderColor: '#f5f8fa',
              padding: '8px 20px',
              borderRadius: '6px',
              fontSize: '0.8rem',
              fontWeight: 500,
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: '#5e6278'
              }
            }
          }
        },
        MuiButton: {
          defaultProps: {
            fontFamily: "Poppins, Helvetica, sans-serif",
            disableElevation: true,
          },
        },
        MuiCheckbox: {
          styleOverrides: {
            root: {
              backgroundColor: '#eee',
              borderRadius: '6px',
              padding: '0',
              margin: '9px',
              color: 'transparent',
            }
          }
        },
        // MuiButton: {
        //   styleOverrides: {
        //     root: {
        //       borderRadius: 0,
        //       color: common.white,
        //       fontFamily:
        //         "Poppins, Oswald, Roboto, 'Helvetica Neue', Arial, sans-serif",
        //       fontSize: 20,
        //       borderWidth: 2,
        //       '&:hover': {
        //         borderWidth: 2,
        //       },
        //     },
        //   },
        //   variants: [
        //     {
        //       props: { variant: 'contained' },
        //       style: {
        //         fontFamily:
        //           "Poppins, Oswald, Roboto, 'Helvetica Neue', Arial, sans-serif",
        //       },
        //     },
        //     {
        //       props: { variant: 'outlined' },
        //       style: {
        //         color: palette.light.primary.main,
        //       },
        //     },
        //     {
        //       props: { variant: 'primary', color: 'primary' },
        //       style: {
        //         border: '4px dashed blue',
        //       },
        //     },
        //   ],
        // },
        MuiList: {
          styleOverrides: {
            root: {},
          },
        },
        MuiMenuItem: {
          styleOverrides: {
            root: {
              color: '#5e6278',
              padding: '10px 20px',
              alignItems: 'stretch',
              '&:focus': {
                backgroundColor: 'transparent',
              },
              "&:hover": {
                backgroundColor: "transparent"
              },
            },
          },
        },
        MuiTooltip: {
          styleOverrides: {
            tooltip: {
              fontSize: '11px',
              lineHeight: '16px',
              color: '#181c32',
              backgroundColor: "#f5f8fa",
              textAlign: 'center',
              whiteSpace: 'pre-line',
              padding: '10px 18px',
            },
          },
        },
        MuiAccordion: {
          styleOverrides: {
            root: {
              color: common.white,
              fontFamily:
                "Poppins, Oswald, Roboto, 'Helvetica Neue', Arial, sans-serif",
            },
          },
        },
      }
      : {
        MuiAppBar: {
          styleOverrides: {
            colorPrimary: {
              backgroundColor: blue[800],
            },
          },
        },
        MuiContainer: {
          styleOverrides: {
            maxWidthLg: {
              [theme.breakpoints.up('lg')]: {
                  maxWidth: '1320px',
              },
            },
          },
        },
        MuiLink: {
          defaultProps: {
            underline: 'none',
          },
          styleOverrides: {
            root: {
              color: '#90929f',
              fontSize: '13px',
              fontWeight: 500,
            }
          }
        },
        MuiFormHelperText: {
          styleOverrides: {
            root: {
              color: 'red'
            }
          }
        },
        MuiTableRow: {
          styleOverrides: {
            root: {
              "&:hover": {
                backgroundColor: "transparent !important"
              }
            }
          }
        },
		    MuiTableCell: {
          styleOverrides: {
            root: {
              color: '#fff',
              borderBottom: '1px dashed #ddd',
            },
          }
        },
        MuiPaper: {
          styleOverrides: {
            root: {
              backgroundImage: "unset"
            }
          }
        },
        MuiInput: {
          defaultProps: {
            disableUnderline: true,
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              color: '#92929f',
              background: '#1b1b29',
              borderColor: '#1b1b29',
              padding: '8px 20px',
              borderRadius: '6px',
              fontSize: '0.8rem',
              fontWeight: 500,
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: '#92929f'
              }
            },
            focus: {
              background: '#1f1f2f'
            }
          }
        },
        MuiTypography: {
          styleOverrides: {
            root: {
              color: '#fff'
            }
          }
        },
        MuiButton: {
          defaultProps: {
            disableElevation: true,
          },
          styleOverrides: {
            root: {
              color: '#fff'
            }
          }
        },
        MuiCheckbox: {
          styleOverrides: {
            root: {
              color: '#565674',
            }
          }
        },
        MuiList: {
          styleOverrides: {
            root: {},
          },
        },
        MuiMenuItem: {
          styleOverrides: {
            root: {
              color: '#90929f',
              alignItems: 'stretch',
              '&:focus': {
                backgroundColor: 'transparent',
              },
              "&:hover": {
                backgroundColor: "transparent"
              },
            },
          },
        },
        MuiTooltip: {
          styleOverrides: {
            tooltip: {
              color: '#cdcdde',
              backgroundColor: "#2b2b40",
              textAlign: 'center',
              whiteSpace: 'pre-line',
              padding: '10px 18px',
            },
            tooltipPlacementRight: {
              padding: '10px 18px',
              margin: '2px 0 2px 16px !important',
              fontSize: '10px',
              fontWeight: '400',
              lineHeight: '13px',
            },
          },
        },
        MuiAccordion: {
          styleOverrides: {
            root: {
              color: common.white,
              fontFamily:
                "Poppins, Oswald, Roboto, 'Helvetica Neue', Arial, sans-serif",
            },
          },
        },
        MuiCardHeader: {
          styleOverrides: {
            avatar: {
              marginRight: '12px',
            }
          }
        },
      }),
  },
});